/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Presets_None_TitleInputs */

const en_transcript_export_presets_none_title = /** @type {(inputs: Transcript_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Presets Available`)
};

const fr_transcript_export_presets_none_title = /** @type {(inputs: Transcript_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun prereglage disponible`)
};

const de_transcript_export_presets_none_title = /** @type {(inputs: Transcript_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Voreinstellungen verfügbar`)
};

const it_transcript_export_presets_none_title = /** @type {(inputs: Transcript_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun preset disponibile`)
};

const ru_transcript_export_presets_none_title = /** @type {(inputs: Transcript_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предустановки отсутствуют`)
};

const es_transcript_export_presets_none_title = /** @type {(inputs: Transcript_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ajustes preestablecidos disponibles`)
};

const zh_cn2_transcript_export_presets_none_title = /** @type {(inputs: Transcript_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无预设可用`)
};

const ja_transcript_export_presets_none_title = /** @type {(inputs: Transcript_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットは利用できません`)
};

const hi_transcript_export_presets_none_title = /** @type {(inputs: Transcript_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई प्रीसेट उपलब्ध नहीं है`)
};

const pt_pt2_transcript_export_presets_none_title = /** @type {(inputs: Transcript_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma predefinição disponível`)
};

/**
* | output |
* | --- |
* | "No Presets Available" |
*
* @param {Transcript_Export_Presets_None_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_presets_none_title = /** @type {((inputs?: Transcript_Export_Presets_None_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Presets_None_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_presets_none_title(inputs)
	if (locale === "de") return de_transcript_export_presets_none_title(inputs)
	if (locale === "it") return it_transcript_export_presets_none_title(inputs)
	if (locale === "ru") return ru_transcript_export_presets_none_title(inputs)
	if (locale === "es") return es_transcript_export_presets_none_title(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_presets_none_title(inputs)
	if (locale === "ja") return ja_transcript_export_presets_none_title(inputs)
	if (locale === "hi") return hi_transcript_export_presets_none_title(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_presets_none_title(inputs)
	return en_transcript_export_presets_none_title(inputs)
});